/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar26 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar26", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.935547 14.306641 C 12.512547 14.306641 13.566406 15.151484 13.566406 16.396484 C 13.566406 17.177484 13.107422 17.871375 11.857422 18.984375 L 10.695312 20.052734 L 10.695312 20.146484 L 13.664062 20.146484 L 13.664062 21.542969 L 8.3085938 21.542969 L 8.3085938 20.347656 L 10.535156 18.251953 C 11.570156 17.294953 11.835938 16.939437 11.835938 16.523438 C 11.835938 16.005437 11.454047 15.658203 10.873047 15.658203 C 10.268047 15.658203 9.8476563 16.069391 9.8476562 16.650391 L 9.8476562 16.683594 L 8.2050781 16.683594 L 8.2050781 16.654297 C 8.2050781 15.253297 9.3005469 14.306641 10.935547 14.306641 z M 18.9375 14.306641 C 20.3585 14.306641 21.476109 15.137219 21.662109 16.324219 L 19.910156 16.324219 C 19.798156 15.938219 19.412594 15.689453 18.933594 15.689453 C 18.064594 15.689453 17.512172 16.586625 17.576172 17.890625 L 17.669922 17.890625 C 17.981922 17.231625 18.615641 16.865234 19.431641 16.865234 C 20.764641 16.865234 21.751953 17.857312 21.751953 19.195312 C 21.750953 20.679312 20.583594 21.728516 18.933594 21.728516 C 17.932594 21.728516 17.111516 21.328938 16.603516 20.585938 C 16.129516 19.960938 15.880859 19.081875 15.880859 18.046875 C 15.880859 15.736875 17.0475 14.306641 18.9375 14.306641 z M 18.917969 18.150391 C 18.287969 18.150391 17.810547 18.623281 17.810547 19.238281 C 17.810547 19.863281 18.292969 20.351562 18.917969 20.351562 C 19.542969 20.351562 20.03125 19.869047 20.03125 19.248047 C 20.03125 18.624047 19.552969 18.150391 18.917969 18.150391 z" />
      </svg>
    );
  }
}

IconCalendar26.defaultProps = {
  className: null
};

IconCalendar26.propTypes = {
  className: PropTypes.string
};

export default IconCalendar26;
